// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
} from "@mui/material";

import {
  addEmployee,
  getNewSubscriptionReachageDetails,
  updateEmployee,
} from "./appoinmentDashboardApi";
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import { getAlldetailSerice } from "../services/servicesListApi";

// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validationPersonalInfo } from "../payment/validation";
import Swal from "sweetalert2";
import ImageUploader from "../../common/imageUpload";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import { UpdateProfile, addProfile, getGusinessProfile } from "./busnessProfileModalapi";
import { ModalHeader } from "../../common/modalHeader";
// import { getAlldetailSerice } from "../services/servicesListApi";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function                           


BusinessProfileModal({
  open,
  setOpen,
  modalData,
  getAll,
}) {
  
  const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [subscription, setSubscription] = useState();
  const [value, setValue] = React.useState("personalInfo");
  const [searchModal, setSearchModal] = useState(false);
  const [cardValue, setCardValue] = useState(null);

  const handleChange_Tab = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };

  const onClose = () => {
    setOpen(false);
  };
  const [search, setSearchvalue] = useState("");

   
  const appnType = useSelector((state) => state.reducer.apppoinmentUerType);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.reducer.detail);
  const [formData, setFormData] = useState(null);
  const userDetail = useSelector((state) => state.reducer.userDetail);

  useEffect(() => {
    
    
  }, [formData]);
  const [dateValue, setDateValue] = useState();
  const [dateValuet, setDateValuet] = useState();

  const [timeValue, setTimeValue] = useState(dayjs());
  const [otpEnabled, setOtpEnabled] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Z\s]*$/;
    
    if (name == "employeeName" && !regex.test(value)) {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else if (typeof value == "object") {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const setDate = (newValue) => {
    setDateValue(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    

    
    setFormData((prev) => {
      return { ...prev, doj: date };
      // return {...prev,date:date}
    });
  };

  const setDatet = (newValue) => {
    setDateValuet(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    

    
    setFormData((prev) => {
      return { ...prev, dob: date };
      // return {...prev,date:date}
    });
  };

  const setTime = (newValue) => {
    setFormData((prev) => {
      if (newValue["$H"] == 20) {
        prev.hour = newValue["$H"] + 12;
      } else {
        prev.hour = newValue["$H"];
      }
      prev.minute = newValue["$m"];
      return { ...prev };
    });
    setTimeValue(newValue);
  };

  const handleTagsChange = (e) => {
    const { value } = e.target;

    
    setFormData({
      ...formData,
      service: value,
    });
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };
  const [tabVale, setTabValue] = useState("salary");
  const tabFn = (e) => {
    setTabValue(e.target.value);
  };
  const handleVerifymobileNumber = () => {
    if (formData.mobileNumber) {
      setOtpEnabled(true);
    }
  };

  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    
      
       
      const formDataobj = new FormData();
      Object.keys(formData).forEach((key, index) => {
        formDataobj.append(key, formData[key]);
      });
      const condition = appnType == "profile";
     
      
      if (!formData?.id) {
        // addEmployee(payload, () => {
        //   setOpen(false);
        //   getAll();
          
        // });
        addProfile(formDataobj,(res)=>{
          console.log("res update",res)
        })
      } else {
        // payload["id"] = modalData?.id;
        UpdateProfile( formDataobj,(res)=>{
          console.log("res update",res)
        })
        // updateEmployee(payload, () => {
          
        //   setOpen(false);
        //   getAll();
        // });
      }
    
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [servicesArr, setservicesArr] = useState([
    {
      serviceName: "Shaving",
      rate: "100.00/Per Head",
    },
    {
      serviceName: "Hair cutting",
      rate: "150.00/Per Head",
    },
  ]);
  const [validationMsgFlag, setValidationMsgFlag] = useState(null);

  const names = [
    "Haircut",
    "Hair Coloring",
    "Hair Styling",
    "Manicure",
    "Pedicure",
    "Facial",
    "Waxing",
    "Massage",
    "Makeup",
    "Bridal Makeup",
    "Threading",
    "Hair Spa",
    "Nail Art",
    "Skin Treatment",
  ];
  useEffect(() => {
    setFormData({
      ...formData,
      billerId: info.billerId,
    });
    setDate(timeValue);
    setTime(timeValue);
    gender("male");
  }, []);

  const infoD = useSelector((state) => state.reducer.detail);
  useEffect(() => {
    // getAlldetailSerice(
    //   {
    //     billerId: infoD?.billerId,
    //   },
    //   (res) => {
    
    //     setservicesArr(res?.data);
    //   }
    // );
  }, []);
  useEffect(() => {
    if (open === true ) {
      console.log("getGusinessProfile",userDetail?.myBusinessId)

      getGusinessProfile(userDetail,(res)=>{
        console.log("getGusinessProfile",res?.data?.data)
        setFormData({...formData,...res?.data?.data})
      })
      
      // setFormData({
      //   ...formData,

      //   id: modalData?.id,
      //   bankName: modalData?.bankName,
      //   bankAccountNumber: modalData?.bankAccountNumber,
      //   bankBranch: modalData?.bankBranch,
      //   employeeId: modalData?.employeeId,
      //   employeeName: modalData?.name,
      //   alternateMobileNumber: modalData?.alternateMobile,
      //   // customerName:modalData?.customerName,
      //   mobileNumber: modalData?.mobile,
      //   designation: modalData?.designation,
      //   pan: modalData?.pan,
      //   salary: modalData?.salary,
      //   ifsc: modalData?.ifsc,
      //   address: modalData?.address,
      //   paymentPercentage: modalData?.paymentPercentage
      //     ? String(modalData?.paymentPercentage)
      //     : "",
      //   // otp: "",
      //   dob: modalData?.dob,
      //   doj: modalData?.doj,
      //   deduction: modalData?.deduction,
      //   email: modalData?.email,
      //   aadhar: modalData?.aadhar,
      //   gender: modalData?.gender,
      //   grade: modalData?.grade,
      //   service: "",

      //   date: "",
      //   hour: "",
      //   minute: "",
      //   isActive: modalData?.isActive,
      // });
      // setSearchvalue({name:modalData?.name,id:modalData?.id})
      // setDateValue(dayjs(modalData?.dob));
      // setDateValuet(dayjs(modalData?.doj));

      // setDateValuet()
      // getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
    } else {
      
      if (!validationMsgFlag) {
        setFormData(null);
      }
    }
  }, [open]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: "10px",
          overflowY: "auto",
          height: "80vh",
        }}
      >
        <ModalHeader            title="Share Business Profile"  onClose={(data)=>{
          setOpen(data)
        }}/>

        <Box sx={{ mt: 4, my: 5 }} display="flex" justifyContent="center">
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <React.Fragment>
              <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>


                    <TextField
                      label="Enterprice Name"
                      name="enterpriseName"
                      value={formData?.enterpriseName}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ className: "mulish" ,shrink: !!formData?.enterpriseName}}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
               
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="address"
                      name="address"
                      value={formData?.address}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ className: "mulish" ,shrink: !!formData?.address}}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Mobile Number"
                      name="mobile"
                      value={formData?.mobileNumber}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ className: "mulish" ,shrink: !!formData?.mobileNumber}}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Email Id"
                      name="emailId"
                      value={formData?.emailId}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ className: "mulish" ,shrink: !!formData?.emailId}}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="specialization"
                      name="specialization"
                      value={formData?.specialization}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ className: "mulish" ,shrink: !!formData?.specialization}}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Achievements"
                      name="achievements"
                      value={formData?.achievements}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ className: "mulish" }}
                      InputLabelProps={{ className: "mulish" ,shrink: !!formData?.achievements}}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Overview"
                      name="overview"
                      value={formData?.overview}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ className: "mulish" ,shrink: !!formData?.overview}}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Terms And Conditions"
                      name="termsAndConditions"
                      value={formData?.termsAndConditions}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ className: "mulish" ,shrink: !!formData?.termsAndConditions}}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
              </React.Fragment>

               

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "end" }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{
                    backgroundColor: "#3695B6",
                    padding: "14px",
                    fontSize: "16px",
                  }}
                >
                  save
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </Modal>
  );
}
